export const AREAS = {
	ALL: '*',
	BILLING: 'billing',
	CONTACTS: 'contacts',
	DASHBOARD: 'dashboard',
	LINKS: 'links',
	MEDIA: 'media',
	METRICS: 'metrics',
	PROFILE: 'profile',
	PROJECTS: 'projects',
	SETTINGS: 'settings',
	SUPPORT: 'support',
	TAGS: 'tags',
	TEAM: 'team',
	USERS: 'users'
};

export const ROLES = {
	ADMINISTRATOR: 'administrator',
	// BILLING: 'billing',
	// MANAGER: 'manager',
	MEMBER: 'member'
	// VIEWER: 'viewer'
};

export const SCOPES = {
	ALL: '*',
	CREATE: 'create',
	EDIT: 'edit',
	DELETE: 'delete',
	DOWNLOAD: 'download',
	VIEW: 'view'
};

// export const PERMISSIONS = {
// 	[ROLES.ADMINISTRATOR]: [`${AREAS.ALL}:${SCOPES.ALL}`],
// 	// [ROLES.BILLING]: [`${AREAS.BILLING}:${SCOPES.ALL}`],
// 	// [ROLES.MANAGER]: [
// 	// 	`${AREAS.CONTACTS}:${SCOPES.ALL}`,
// 	// 	`${AREAS.LINKS}:${SCOPES.ALL}`,
// 	// 	`${AREAS.PROJECTS}:${SCOPES.ALL}`,
// 	// 	`${AREAS.SUPPORT}:${SCOPES.ALL}`
// 	// ],
// 	[ROLES.MEMBER]: [
// 		`${AREAS.CONTACTS}:${SCOPES.ALL}`,
// 		`${AREAS.LINKS}:${SCOPES.VIEW}`,
// 		`${AREAS.MEDIA}:${SCOPES.ALL}`,
// 		`${AREAS.PROJECTS}:${SCOPES.ALL}`,
// 		`${AREAS.TAGS}:${SCOPES.ALL}`,
// 		`${AREAS.USERS}:${SCOPES.VIEW}`
// 	]
// 	// [ROLES.VIEWER]: [
// 	// 	`${AREAS.MEDIA}:${SCOPES.VIEW}`,
// 	// 	`${AREAS.MEDIA}:${SCOPES.DOWNLOAD}`
// 	// ]
// };
